<template>
    <div class='gradeDetail'>
        <GradeDetail :data="data"></GradeDetail>
        <div class="ftBtnBox" >
            <Button @handleClick="$router.push('/consultant/minestudent/main/studentMessage/grade/list')" :type="'btnGray'" name="返回" ></Button>
        </div>
    </div>
</template>a
<script>
import Button from '@/components/Button.vue'
import GradeDetail from '@/components/consultant/GradeDetail.vue'
export default {
    name: "gradeAdd",
    components: {
        Button,
        GradeDetail
    },
    data() {
        return {
            data: {},
            studentId: sessionStorage.getItem('myStudentStudentId'),//学生id
            // "data": {
            //     "id": 40,
            //     "studentId": 1,
            //     "grade": 5,
            //     "name": 2,
            //     "totalScore": "638",
            //     "totalRank": 50,
            //     "totalPeople": 600,
            //     "remark": "1111111111111111111111",
            //     "subjects": "物理,化学,生物",
            //     "createdAt": "2021-01-21 11:01:12",
            //     "updatedAt": "2021-01-21 11:01:12",
            //     "deletedAt": null,
            //     "gradeName": "高三上学期",
            //     "nameName": "第二次月考",
            //     "subject": [{
            //         "subject": "语文",
            //         "score": "118",
            //         "rank": 20,
            //         "totalPeople": 600,
            //         "important": 0,
            //         "remark": "11111111"
            //     }, {
            //         "subject": "数学",
            //         "score": "120",
            //         "rank": 20,
            //         "totalPeople": 600,
            //         "important": 0,
            //         "remark": "11111111111"
            //     }, {
            //         "subject": "外语",
            //         "score": "120",
            //         "rank": 18,
            //         "totalPeople": 600,
            //         "important": 0,
            //         "remark": "11111111111111111111111"
            //     }, {
            //         "subject": "物理",
            //         "score": "90",
            //         "rank": 16,
            //         "totalPeople": 200,
            //         "important": 1,
            //         "remark": "1111111111111"
            //     }, {
            //         "subject": "化学",
            //         "score": "95",
            //         "rank": 20,
            //         "totalPeople": 200,
            //         "important": 1,
            //         "remark": "11111111111111111111111"
            //     }, {
            //         "subject": "生物",
            //         "score": "95",
            //         "rank": 18,
            //         "totalPeople": 200,
            //         "important": 1,
            //         "remark": "111111111111111"
            //     }],
            //     "actionSubject": [{
            //         "subject": "语文",
            //         "semesterTargetScore": "100",
            //         "semesterRankingGoals": "12",
            //         "stageScoreGoal": "118",
            //         "stageRankingGoal": "20"
            //     }, {
            //         "subject": "数学",
            //         "semesterTargetScore": "100",
            //         "semesterRankingGoals": "12",
            //         "stageScoreGoal": "122",
            //         "stageRankingGoal": "12"
            //     }, {
            //         "subject": "外语",
            //         "semesterTargetScore": "100",
            //         "semesterRankingGoals": "12",
            //         "stageScoreGoal": "130",
            //         "stageRankingGoal": "10"
            //     }, {
            //         "subject": "物理",
            //         "semesterTargetScore": "100",
            //         "semesterRankingGoals": "12",
            //         "stageScoreGoal": "90",
            //         "stageRankingGoal": "10"
            //     }, {
            //         "subject": "化学",
            //         "semesterTargetScore": "100",
            //         "semesterRankingGoals": "12",
            //         "stageScoreGoal": "95",
            //         "stageRankingGoal": "19"
            //     }, {
            //         "subject": "生物",
            //         "semesterTargetScore": "100",
            //         "semesterRankingGoals": "12",
            //         "stageScoreGoal": "90",
            //         "stageRankingGoal": "10"
            //     }, {
            //         "subject": "总分\/名次",
            //         "semesterTargetScore": null,
            //         "semesterRankingGoals": null,
            //         "stageScoreGoal": 645,
            //         "stageRankingGoal": 81
            //     }]
            // }
        }
    },
    created() {
        console.log(this.$route)
        this.detailAchievement();
    },
    methods: {
        // 获取成绩列表
        detailAchievement(){
            let id = this.$route.query.id;
            let studentId = this.studentId;
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.grade.detailAchievement, {
                studentId: studentId,
                id:id
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                if (res.data.code == 2000) {
                    this.data = res.data.data;
                }else{

                }
            })
        },
    },
}
</script>

<style scoped lang="less">
.gradeDetail {
    padding-bottom: 40px;
    font-size: 16px;
    .ftBtnBox {
        padding: 45px 0;
        display: flex;
        justify-content: center;
    }
}
</style>